import React, { useState } from "react";
import { LoadScript, GoogleMap, Marker } from "@react-google-maps/api";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp, faViber } from "@fortawesome/free-brands-svg-icons";

const libraries = ["places"];

const mapContainerStyle = {
  width: "100%",
  height: "400px",
};

const center = {
  lat: 43.2141,
  lng: 27.9147,
};

const BookingForm = () => {
  const [setMapVisible] = useState(false);
  const [markerPosition, setMarkerPosition] = useState(center);
  const [selectedField, setSelectedField] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    pickup: "",
    destination: "",
    passengers: "",
  });
  const [suggestions, setSuggestions] = useState([]);
  const [pickupMapVisible, setPickupMapVisible] = useState(false);
  const [destinationMapVisible, setDestinationMapVisible] = useState(false);

  const handleMarkerDragEnd = (event) => {
    const newPosition = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };
    setMarkerPosition(newPosition);
  };

  const handleSaveLocation = (e) => {
    e.preventDefault();
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: markerPosition }, (results, status) => {
      if (status === "OK" && results[0]) {
        setFormData((prev) => ({
          ...prev,
          [selectedField]: results[0].formatted_address,
        }));
        setMapVisible(false);
      } else {
        alert("Address not found. Please try again!");
      }
    });
  };

  const handleGetCurrentLocation = (e) => {
    e.preventDefault();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const currentPosition = { lat: latitude, lng: longitude };
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ location: currentPosition }, (results, status) => {
            if (status === "OK" && results[0]) {
              setFormData((prev) => ({
                ...prev,
                pickup: results[0].formatted_address,
              }));
            } else {
              alert("Unable to retrieve address from your location.");
            }
          });
        },
        (error) => {
          alert(
            "Unable to access your location. Please check your browser settings."
          );
          console.error("Geolocation error:", error);
        }
      );
    } else {
      alert("Geolocation is not supported by your browser.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "pickup" || name === "destination") {
      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions(
        {
          input: value,
          componentRestrictions: { country: "bg" },
        },
        (predictions, status) => {
          if (status === "OK" && predictions) {
            setSuggestions(predictions.map((p) => p.description));
          } else {
            setSuggestions([]);
          }
        }
      );
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setFormData((prev) => ({ ...prev, [selectedField]: suggestion }));
    setSuggestions([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://airporttaxitransfersvarna.com/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Your booking details have been sent to your email!",
        });
      } else {
        throw new Error("Failed to send email");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to send your booking details. Please try again later.",
      });
    }
  };

  return (
    <LoadScript
      googleMapsApiKey="AIzaSyAfwCc4NgXYmawcy3GWQbCZOUXhd4esl_I"
      libraries={libraries}
    >
      <div className="booking-form">
        <form onSubmit={handleSubmit}>
          <h1>Airport Taxi Transfers Varna</h1>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleInputChange}
          />
          <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
              required
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleInputChange}
          />
          <div className="autocomplete-container">
            <input
              type="text"
              name="pickup"
              placeholder="Pickup Location"
              value={formData.pickup}
              onChange={handleInputChange}
              onClick={() => setSelectedField("pickup")}
            />
            {selectedField === "pickup" && suggestions.length > 0 && (
              <ul className="suggestions-list">
                {suggestions.map((suggestion, index) => (
                  <li
                    key={index}
                    onClick={() => handleSuggestionClick(suggestion)}
                  >
                    {suggestion}
                  </li>
                ))}
              </ul>
            )}
            <div className="contact-form-button">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedField("pickup");
                  setPickupMapVisible(!pickupMapVisible);
                }}
                className="map-toggle-button submit-button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-arrow-up"
                >
                  <line x1="12" y1="19" x2="12" y2="5"></line>
                  <polyline points="5 12 12 5 19 12"></polyline>
                </svg>
                {pickupMapVisible ? "Close Map" : "Choose on Map"}
              </button>
              <button
                onClick={handleGetCurrentLocation}
                className="location-button submit-button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-arrow-up"
                >
                  <line x1="12" y1="19" x2="12" y2="5"></line>
                  <polyline points="5 12 12 5 19 12"></polyline>
                </svg>
                Get Current Location
              </button>
            </div>
          </div>

          <div className="autocomplete-container">
            <input
              type="text"
              name="destination"
              placeholder="Destination Location"
              value={formData.destination}
              onChange={handleInputChange}
              onClick={() => setSelectedField("destination")}
            />
            {selectedField === "destination" && suggestions.length > 0 && (
              <ul className="suggestions-list">
                {suggestions.map((suggestion, index) => (
                  <li
                    key={index}
                    onClick={() => handleSuggestionClick(suggestion)}
                  >
                    {suggestion}
                  </li>
                ))}
              </ul>
            )}
            <div className="contact-form-button">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedField("destination");
                  setDestinationMapVisible(!destinationMapVisible);
                }}
                className="map-toggle-button submit-button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-arrow-up"
                >
                  <line x1="12" y1="19" x2="12" y2="5"></line>
                  <polyline points="5 12 12 5 19 12"></polyline>
                </svg>
                {destinationMapVisible ? "Close Map" : "Choose on Map"}
              </button>
            </div>
          </div>
          <input
            type="number"
            name="passengers"
            placeholder="Number of Passengers"
            value={formData.passengers}
            onChange={handleInputChange}
          />
          <div className="contact-form-button">
            <button type="submit" className="submit-button">
              Submit
            </button>
          </div>
          <div className="contact-buttons">
            <button
              onClick={() =>
                window.open("https://wa.me/359888850884", "_blank")
              }
              className="whatsapp-button"
            >
              <FontAwesomeIcon
                icon={faWhatsapp}
                style={{ marginRight: "8px" }}
              />
              Text us on WhatsApp
            </button>
            <button
              onClick={() =>
                window.open("viber://chat?number=359888850884", "_blank")
              }
              className="viber-button"
            >
              <FontAwesomeIcon icon={faViber} style={{ marginRight: "8px" }} />
              Text us on Viber
            </button>
          </div>
          <div className="contact-form-button">
            <button
              onClick={(e) => {
                e.preventDefault();
                window.open("tel:+359888850884", "_self");
              }}
              className="call-button submit-button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                width="20"
                height="20"
                fill="currentColor"
                style={{ marginRight: "8px" }}
              >
                <path d="M511.1 387.8c0 15.2-1.7 30.6-7.2 45.2-8.2 22.4-23.6 40.3-43.2 52.6-13.4 8.4-28.4 12.4-43.7 12.4-31.7 0-62.8-10.7-93.2-25.4-29.2-14.3-57.4-33.3-83.5-54.6-47.4-38.8-89.2-85.1-124.6-137.8C90.5 234.5 66.1 192.8 48.3 145.2 30.8 98.4 13.4 50.6 10.6 3.2 10.2-1.2 10.2-5.2 14.1-8.2c1.5-1.2 2.8-2.3 4.2-3.5C32.8-19.6 58.4-26 83.6-18.8c25.8 7.5 50.6 21.1 71.2 39.5 10.1 8.8 19.1 19.4 26.7 31.5 9.6 15 17.8 30.8 23.8 47.7 5.3 14.7 2.5 29.4-8.5 42.8l-28.5 33.6c-.3 .3-.6 .6-.8 .9-4.2 5.2-4.9 11.7-2.5 17.7 13.3 33.2 32.6 64.3 57.4 91.7 24.8 27.6 53.8 50.5 86.2 66.2 6.1 3 12.9 2.5 17.6-1.2l37.3-29.4c10.9-8.6 22.8-11.5 35.8-8.5 16.5 3.8 32.5 9.2 48.2 16.2 17.2 7.7 32.5 18 47 30.4 14.5 12.3 26.3 27.4 34.2 45 5.6 13 8.6 26.5 8.6 40.4z" />
              </svg>
              Direct Call
            </button>
          </div>
            <div class="card-container">
              <span>We accept cards</span>
              <img src="https://cdn4.iconfinder.com/data/icons/flat-brand-logo-2/512/visa-1024.png" alt="Visa" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/MasterCard_Logo.svg/600px-MasterCard_Logo.svg.png" alt="Mastercard" />
            </div>
          {pickupMapVisible && (
            <div>
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={markerPosition}
                zoom={14}
                onClick={(e) =>
                  setMarkerPosition({
                    lat: e.latLng.lat(),
                    lng: e.latLng.lng(),
                  })
                }
              >
                <Marker
                  position={markerPosition}
                  draggable={true}
                  onDragEnd={handleMarkerDragEnd}
                />
              </GoogleMap>
              <button
                className="submit-button"
                onClick={(e) => {
                  e.preventDefault();
                  handleSaveLocation(e);
                  setPickupMapVisible(false);
                }}
              >
                Save Pickup Location
              </button>
            </div>
          )}

          {destinationMapVisible && (
            <div>
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={markerPosition}
                zoom={14}
                onClick={(e) =>
                  setMarkerPosition({
                    lat: e.latLng.lat(),
                    lng: e.latLng.lng(),
                  })
                }
              >
                <Marker
                  position={markerPosition}
                  draggable={true}
                  onDragEnd={handleMarkerDragEnd}
                />
              </GoogleMap>
              <button
                className="submit-button"
                onClick={(e) => {
                  e.preventDefault();
                  handleSaveLocation(e);
                  setDestinationMapVisible(false);
                }}
              >
                Save Destination Location
              </button>
            </div>
          )}
        </form>
      </div>
    </LoadScript>
  );
};

export default BookingForm;
